// Registers the offline app shell (Charter O-5, Stage 5 delta A). Production
// builds only: under `vite` dev the modules are served unbundled and a worker
// would only get in the way. A failed registration never breaks the app — it
// just stays online-only, as before.

export const shouldRegisterServiceWorker = (env: { PROD: boolean }, nav: Navigator | undefined): boolean =>
  Boolean(env.PROD && nav && 'serviceWorker' in nav)

export const registerServiceWorker = (): void => {
  const nav = typeof navigator !== 'undefined' ? navigator : undefined
  if (!shouldRegisterServiceWorker(import.meta.env, nav)) return
  const register = () => {
    nav!.serviceWorker.register('/sw.js', { scope: '/' }).catch((error) => {
      console.warn('[offline] service worker registration failed; the app stays online-only', error)
    })
  }
  if (document.readyState === 'complete') register()
  else window.addEventListener('load', register, { once: true })
}
